import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Route that requires user to be authenticated
export const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show nothing while auth state is being determined
  if (isLoading) return null;
  
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

// Route that requires user to be an admin
export const AdminRoute = () => {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();

  // Show nothing while auth state is being determined
  if (isLoading) return null;
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  return isAdmin ? <Outlet /> : <Navigate to="/" />;
};

// Route that redirects authenticated users (e.g., login/register pages)
export const PublicOnlyRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show nothing while auth state is being determined
  if (isLoading) return null;
  
  return isAuthenticated ? <Navigate to="/" /> : <Outlet />;
};